/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bell': {
    width: 16,
    height: 16,
    viewBox: '0 0 14.17 16.93',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M13.67 12.07H13V5.93a5.93 5.93 0 00-11.86 0v6.14H.5a.5.5 0 000 1h13.17a.5.5 0 000-1zM2.15 5.93a4.93 4.93 0 019.86 0v6.14H2.15z" _fill="#c4c4c4"/><path pid="1" d="M9.83 14.18a2.75 2.75 0 01-5.5 0" _fill="#74777a"/></g></g>'
  }
})
